import styled from 'styled-components';

export const NotificationsListContainer = styled('div')`
  position: fixed;
  display: flex;
  flex-flow: column;
  align-items: center;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
  min-width: 600px;
  max-width: 900px;
`;
